var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShop = function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#shop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.572 14.571v7.715a.857.857 0 0 0 .857.857h17.143a.857.857 0 0 0 .857-.857V14.57M22.286 10.286H1.714a.857.857 0 0 1-.857-.857V6L2.95 1.8A1.71 1.71 0 0 1 4.49.857H19.51a1.72 1.72 0 0 1 1.543.943l2.09 4.2v3.429a.857.857 0 0 1-.856.857M13.714 14.571v8.572M2.572 17.143h11.142M.857 6h22.286"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shop_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgShop;